import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { handleNonStandardErrors } from '../apis/HttpBaseApiWrapper';
import { TReactQueryError } from '../apis/common.interfaces';
import { useAuthService } from '../apis/auth/useAuthService';
import { IAuthParams, ILoggedInUser } from '../apis/auth/auth.interfaces';

type TMutationError = TReactQueryError<{ message: string }>;

export const useAuthUserHook = (
  options?: UseMutationOptions<
    ILoggedInUser,
    TMutationError,
    IAuthParams,
    unknown
  >
) => {
  const { authoriseUser } = useAuthService();

  return useMutation({
    mutationFn: (param: IAuthParams) => {
      return authoriseUser(param);
    },
    onSuccess: async () => {
      // TODO: clear logged user
      // await queryClient.invalidateQueries({
      //   queryKey: [getAllocationGroupByIdKey],
      // })
    },
    onError: handleNonStandardErrors,
    retry: false,
    ...options,
  });
};
